// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 164 ? "chart" : chunkId) + ".bundle.771fd8694bd41b5b9052fc47e71af1c36125d36c.js";
};